export interface Theme {
  paper: string
  ink: string
  soft: string
  accent: string
  hair: string
  illu: string
  panel: string
  panelSoft: string
  panelAcc: string
}

export const THEMES: Record<string, Theme> = {
  silences: {
    paper: '#F1F1EC',
    ink: '#1F2124',
    soft: '#4C5157',
    accent: '#3D5F7D',
    hair: '#DEDFD8',
    illu: 'repeating-linear-gradient(135deg, #E4E5DD 0 6px, #ECEDE6 6px 12px)',
    panel: '#1E2831',
    panelSoft: '#A9B8C6',
    panelAcc: '#B9D3E8',
  },
  jours: {
    paper: '#F5EFE4',
    ink: '#241C13',
    soft: '#5C4C3B',
    accent: '#8A5A2E',
    hair: '#E4DACA',
    illu: 'repeating-linear-gradient(135deg, #EAE0CE 0 6px, #F0E8DA 6px 12px)',
    panel: '#2A211A',
    panelSoft: '#C0B0A0',
    panelAcc: '#E0BF9A',
  },
  marees: {
    paper: '#EDF1F0',
    ink: '#182322',
    soft: '#41544F',
    accent: '#2F6A63',
    hair: '#D6E0DD',
    illu: 'repeating-linear-gradient(135deg, #DDE6E3 0 6px, #E6EDEB 6px 12px)',
    panel: '#1B2C2A',
    panelSoft: '#A3BDB8',
    panelAcc: '#9FD3CA',
  },
  nord: {
    paper: '#ECEDF1',
    ink: '#1C1E26',
    soft: '#494D5C',
    accent: '#4A4F86',
    hair: '#DADCE4',
    illu: 'repeating-linear-gradient(135deg, #DEE0E8 0 6px, #E6E8EE 6px 12px)',
    panel: '#20222E',
    panelSoft: '#AEB2C6',
    panelAcc: '#BFC2EA',
  },
}
